import Vue from 'vue';
if (document.getElementById('notify-bell-mobile')) {
    let notifyBell = new Vue({
        el: "#notify-bell-mobile",
        data: {
            user : isUser,
            notify: 1,
            ready: false,
            notifications: {
                items: null,
                bell: null,
                interval: null,
            },
        },
        watch: {},
        filters: {

        },
        methods: {
            loadData: function () {
                this.noSeen = [];
                $.get('/api/v1/notifications', function (response) {
                    this.notifications.items = response;
                    this.ready = true
                }.bind(this));

                this.notifications.bell = !this.isObjectEmpty(this.notifications.items);
            },
            isObjectEmpty: function (Obj) {
                for (var key in Obj) {
                    if (Obj.hasOwnProperty(key))
                        return false;
                }
                return true;
            },
        },
        mounted: function () {

        },
        created: function () {
            if(this.user === 1) {
                this.loadData();
                // todo: Отправляется 2 запроса - см notify-bell
                // Так же надо проверить - вроде только требуется кол-во уведомлений получать, а не всё содержимое
                // this.notifications.interval = setInterval(function () {
                //     this.loadData();
                // }
                //     .bind(this), 90000);
            }
        },
        computed: {
            notifyNoSeen: function() {
                var arr = [];
                for(var index in this.notifications.items) {
                    var item  = this.notifications.items[index];
                    if(item.isSeen === false) {
                        arr.push(item)
                    }
                }
                return arr

            },
            notifyPlus: function () {
                if (this.notifyNoSeen.length > 9) {
                    return 'notify-bell_plus';
                }
                else if (this.notifyNoSeen.length === 0 || this.notifyNoSeen.length === null) {
                    return 'notify-bell_no-notify';
                }
            }
        }
    });
}